<div class="d-none d-xl-block">
  <div class="card bg-transparent border rounded shadow-sm">
    <div class="card-header bg-transparent d-flex justify-content-between align-items-center border-bottom">
      <h6 class="mb-0 card-header bg-transparent border-0">Portal Positions</h6>

      <button
        class="btn btn-sm btn-primary fab d-flex justify-content-center align-items-center shadow-sm"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#create_position"
        aria-label="Create Position"
        v-if="user_details?.user_role === 'admin' || portal_admin"
      >
        +
      </button>
    </div>

    <div class="card-body mt-0 maximum-height overflow-auto">
      <!-- Loading -->
      <div v-if="loading" class="text-center py-5 w-100">
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 mb-0 text-muted">Loading Positions...</p>
      </div>

      <!-- List -->
      <table v-else-if="positions.length" class="table mb-0">
        <tbody>
          <!-- your requested row style -->
          <tr v-for="position in visiblePositions" :key="position.position_id" class="border-0">
            <td class="border-0 align-middle">
              <div class="d-flex justify-content-between align-items-center">
                <a class="text-decoration-none text-dark d-flex align-items-center" href="#" @click.prevent>
                  <span class="rounded-circle bg-yellow p-2 shadow-sm color-purple d-flex align-items-center justify-content-center me-2">
                    <i class="bx bxs-user-pin fs-5 text-change"></i>
                  </span>
                  <span class="text-xxs fw-500">{{ position.position_name }}</span>
                </a>

                <div class="dropdown position-static" v-if="user_details?.user_role === 'admin' || portal_admin">
                  <i class="bx bx-dots-vertical-rounded cursor-pointer" data-bs-toggle="dropdown"></i>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <!-- Set the record, then let Bootstrap show the modal -->
                      <a
                        class="dropdown-item text-xxs"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_position_modal"
                        @click.prevent="open_edit_modal(position)"
                      >Edit</a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item text-xxs"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#assign_position_modal"
                        @click.prevent="open_assign_modal(position)"
                      >Assign</a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item text-xxs text-danger"
                        href="#"
                        @click.prevent="delete_position(position.position_id, portal_id)"
                      >Delete</a>
                    </li>
                  </ul>
                </div>

              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Empty state -->
      <p v-else class="text-secondary text-xxs text-center">No Positions Available</p>

      <!-- See More / See Less -->
      <div v-if="positions.length > visibleCount" class="text-center my-2">
        <button class="btn btn-sm btn-transparent text-secondary" @click="toggleShowMore">
          <i v-if="showAll" class="bx bxs-up-arrow-circle me-1"></i>
          <i v-else class="bx bxs-down-arrow-circle me-1"></i>
          {{ showAll ? 'See Less' : 'See More' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Create Position Modal -->
<teleport to="body">
  <div class="modal fade" id="create_position" tabindex="-1" aria-labelledby="create_position_modal_label"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="exampleModalLabel">Create a Position</p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
        </button>
        </div>
        <form @submit.prevent="create_role">
          <div class="modal-body">
            <div class="mb-3">
              <label for="position_name" class="form-label text-xxs fw-500">
                Position Name <span class="text-danger">*</span>
              </label>
              <input type="text" class="form-control rounded text-xxs" id="position_name"
                placeholder="Enter position name" v-model="position_name">
              <p v-if="errors && errors.position_name" class="text-danger text-xxs">
                {{ errors.position_name }}
              </p>

              <!-- <p v-if="errors.position_name" class="text-danger text-xxs">{{ errors.position_name }}</p> -->
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded">Create</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>

<!-- Edit Modal (always in DOM; Bootstrap can find it) -->
<teleport to="body">
  <div
    class="modal fade"
    id="edit_position_modal"
    tabindex="-1"
    aria-labelledby="edit_position_label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="edit_position_label">Edit Position</p>
          <button
              type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal"
              aria-label="Close">
          </button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="save_position_name">
            <div class="mb-3">
              <label class="form-label fw-semibold text-xxs">
                Position Name <span class="text-danger">*</span>
              </label>
              <input
                v-model="editingPosition.newName"
                type="text"
                class="form-control rounded text-xxs"
                placeholder="Enter position name"
              />
              <p v-if="errors && errors.position_name" class="text-danger text-xxs mb-0">
                {{ errors.position_name }}
              </p>
            </div>

            <div class="text-end">
              <button type="submit" class="btn btn-primary btn-sm text-xxs px-4 rounded" data-bs-dismiss="modal">
                Save
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
</teleport>

<!-- Assign Position Modal -->
<teleport to="body">
  <div class="modal fade" id="assign_position_modal" tabindex="-1" aria-labelledby="assign_position_modal_label"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="assign_position_modal_label">
            Assign {{ selected_position?.position_name }} to User
          </p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>

        <div class="modal-body">
          <table v-if="portalUsers.length" class="table table-striped text-xxs mb-0">
            <thead>
              <tr>
                <th>No.</th>
                <th>User</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in portalUsers" :key="user.id">
                <td>{{ index + 1 }}</td>
                <td>{{ user.full_name || user.username }}</td>
                <td>
                  <button
                    v-if="!isUserAssignedToPosition(user, selected_position.position_id)"
                    class="btn btn-sm btn-primary rounded text-xxs"
                    @click="assign_portal_position(user.user.id, selected_position.position_id, portal_id)"
                  >
                  Assign
                  </button>
                  <button
                    v-else
                    class="btn btn-sm btn-danger rounded text-xxs"
                    @click="unassign_portal_position(user.user.id, selected_position.position_id, portal_id)"
                  >
                  Unassign
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <p v-else class="text-center text-muted text-xxs mb-0 py-2">
            No users found for this portal.
          </p>
        </div>
      </div>
    </div>
  </div>
</teleport>


<!-- Mobile Offcanvas -->
<div
  class="offcanvas offcanvas-end d-xl-none mt-2"
  tabindex="-1"
  id="positionsOffcanvas"
  aria-labelledby="positionsOffcanvasLabel"
>


  <div class="offcanvas-body p-2">
    <div class="d-flex justify-content-between mt-5">
        <div class="d-flex align-items-center mt-3">
            <h5 class="offcanvas-title mx-2" id="portals_label">Portal Positions</h5>
            <div class="d-flex justify-content-end mb-2">
        <button
          class="fab border-0 shadow"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#create_position"
          v-if="user_details?.user_role === 'admin' || portal_admin"
        >
          +
        </button>
      </div>
        </div>

            <button type="button" class="btn-close text-reset mt-4" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
    <!-- Reuse your positions list -->
    <div class="card bg-transparent border-0 shadow-none">



      <div v-if="loading" class="text-center py-4">
        <div class="spinner-border text-secondary"></div>
        <p class="text-muted text-xxs mt-2">Loading Positions...</p>
      </div>

      <table v-else-if="positions.length" class="table mb-0">
        <tbody>
          <tr v-for="position in visiblePositions" :key="position.position_id">
            <td class="border-0">
              <div class="d-flex justify-content-between align-items-center">
                <span class="text-xxs fw-500">
                  {{ position.position_name }}
                </span>

                <div class="dropdown" v-if="user_details?.user_role === 'admin' || portal_admin">
                  <i class="bx bx-dots-vertical-rounded" data-bs-toggle="dropdown"></i>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a class="dropdown-item text-xxs"
                         href="#"
                         data-bs-toggle="modal"
                         data-bs-target="#edit_position_modal"
                         @click.prevent="open_edit_modal(position)">
                        Edit
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item text-xxs"
                         href="#"
                         data-bs-toggle="modal"
                         data-bs-target="#assign_position_modal"
                         @click.prevent="open_assign_modal(position)">
                        Assign
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item text-danger text-xxs"
                         href="#"
                         @click.prevent="delete_position(position.position_id, portal_id)">
                        Delete
                      </a>
                    </li>
                  </ul>
                </div>

              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <p v-else class="text-center text-secondary text-xxs">
        No Positions Available
      </p>

    </div>
  </div>
</div>
